// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__21iwQ","inputWrap":"Table_inputWrap__1b8uX","col":"Table_col__2lfXG","bmiTooltip":"Table_bmiTooltip__3UCHq"};